<div class="provision-modal">
    <div class="provision-modal__header">
        <h3>Add new gateway</h3>
        <button type="button" class="provision-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    @if (provisionedCode) {
        <div class="provision-modal__success">
            <p class="message">Gateway added. Give this activation code to the customer:</p>
            <div class="code">{{ provisionedCode }}</div>
            @if (duplicateWarning) {
                <!-- The gateway WAS created; this only says the uid is not unique. -->
                <p class="warning">{{ duplicateWarning }}</p>
            }
            <button type="button" class="provision-modal__submit" (click)="activeModal.close(true)">Done</button>
        </div>
    } @else {
        <form class="provision-modal__body" (ngSubmit)="submit()">
            <label class="field">
                <span>UID</span>
                <input ngbAutofocus type="text" name="uid" [(ngModel)]="uid" autocomplete="off" required />
            </label>

            @if (error) {
                <p class="error">{{ error }}</p>
            }

            <button type="submit" class="provision-modal__submit" [disabled]="submitting || !uid.trim()">
                Save
            </button>
        </form>
    }
</div>
